import DashboardWrapper from "components/new-stuff/ui/DashboardWrapper"
import { CardListSkeleton } from "components/new-stuff/ui/Skeleton"
import { useState } from "react"

import ViewGlobal from "./ViewGlobal"
import ViewCurrency from "./ViewCurrency"
import { useGet, usePost } from "utils/useFetch"
import { useLocation } from "react-router-dom"
import { ICurrencyInfo, ICurrencyInfoRes } from "./interface/payouts"
import { availableFlags } from "utils/flags"
import { ICurrencies } from "pages/dashboard/wallets/integration/interface/kyc"
import { useQuery } from "@tanstack/react-query"
import { COMMON_ENDPOINTS, commonService } from "services/commonService"
import {
  paymentSchedulesService,
  PAYMENT_SCHEDULES_ENDPOINTS,
} from "services/paymentSchedulesService"

const ViewPaymentDetails = () => {
  const myParam = useLocation().search
  const x = new URLSearchParams(myParam).get("x")
  const location = useLocation()
  const { title } = location.state || {}
  const [activeCurrency, setActiveCurrency] = useState<ICurrencyInfo | null>(
    null
  )
  const { isLoading: isCurrenciesLoading, data: currenciesData } =
    useQuery<ICurrencyInfoRes>({
      queryFn: () => paymentSchedulesService.viewCurrencies(x),
      queryKey: [PAYMENT_SCHEDULES_ENDPOINTS.VIEW_CURRENCIES, x],
      onSuccess: (data: any) => {
        {
          data?.data?.length > 1
            ? setActiveCurrency({
                currency_code: "Global",
                currency_symbol: "$",
                total: 0,
                count: 0,
              })
            : setActiveCurrency({
                currency_code: data?.data[0]?.currency_code,
                currency_symbol: data?.data[0]?.currency_symbol,
                total: data?.data[0]?.total,
                count: data?.data[0]?.count,
              })
        }
      },
    })

  const { isLoading: isCurrencyLoading, data: flagCurrencies } = useQuery<
    IBaseRes<ICurrencies[]>
  >({
    queryFn: () => commonService.getCurrencies(),
    queryKey: [COMMON_ENDPOINTS.GET_CURRENCIES],
  })
  const totalSum =
    currenciesData?.data?.reduce((sum, item) => sum + item.count, 0) || 0

  const displayedCurrencies = [
    ...(currenciesData && currenciesData?.data?.length > 1
      ? [
          {
            currency_code: "Global",
            currency_symbol: "$",
            total: 0,
            count: totalSum,
          },
        ]
      : []),
    ...(currenciesData?.data ?? []),
  ]

  return (
    <DashboardWrapper>
      {isCurrenciesLoading ? (
        <CardListSkeleton
          items={3}
          lines={2}
        />
      ) : (
        <div>
          <h6 className="text-sm text-padeBlack font-circular mb-3">
            Payment for {title}
          </h6>
          <div className="flex items-start justify-start gap-10 mb-[26px] w-full overflow-auto scrollbar-hide">
            {displayedCurrencies?.map((curr, index) => (
              <button
                key={index}
                className={`py-[5px] px-[10px] border rounded-full flex  justify-between min-w-[125px] items-center gap-1 ${
                  activeCurrency?.currency_code === curr?.currency_code
                    ? "border-primary500 bg-[#E7ECF8]"
                    : "bg-white"
                }`}
                onClick={() => {
                  setActiveCurrency(curr)
                }}
              >
                <div className="flex items-center gap-1">
                  <img
                    src={
                      availableFlags?.find(
                        (item) => item?.code === curr?.currency_code
                      )?.flag || ""
                    }
                    alt=""
                    className="h-6 w-6"
                  />
                  <p className="text-padeBlack text-sm font-circular">
                    {curr?.currency_code}
                  </p>
                </div>
                <p className=" px-2 py-0.5 rounded-5px text-xs bg-[#E7ECF8] font-avenir text-padeBlack">
                  {curr?.count}
                </p>
              </button>
            ))}
          </div>
          {activeCurrency?.currency_code === "Global" ? (
            <ViewGlobal currencies={currenciesData} />
          ) : activeCurrency?.currency_code !== null ? (
            <ViewCurrency
              activeCurrency={activeCurrency}
              currencies={flagCurrencies}
            />
          ) : null}
        </div>
      )}
    </DashboardWrapper>
  )
}

export default ViewPaymentDetails
